import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "product-page" }
const _hoisted_2 = { class: "container header-padding-compensation" }
const _hoisted_3 = { class: "product-card-container" }
const _hoisted_4 = { class: "container header-padding-compensation" }
const _hoisted_5 = {
  key: 0,
  class: "skeletons-container"
}
const _hoisted_6 = { class: "row placeholder-glow" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = { class: "skeleton-image-container" }
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "d-flex justify-content-between" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-6 position-relative" }
const _hoisted_14 = {
  key: 0,
  class: "coming-soon-container"
}
const _hoisted_15 = { class: "coming-soon-text" }
const _hoisted_16 = { class: "product-image-background animate__animated animate__fadeInLeft" }
const _hoisted_17 = { class: "product-image-container" }
const _hoisted_18 = ["srcset", "alt"]
const _hoisted_19 = ["srcset", "alt"]
const _hoisted_20 = ["srcset", "alt"]
const _hoisted_21 = ["srcset", "alt"]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-pencil" }, null, -1)
const _hoisted_24 = { class: "col-lg-6" }
const _hoisted_25 = { class: "product-info" }
const _hoisted_26 = { class: "product-headline" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "price-button-container" }
const _hoisted_29 = { class: "product-price" }
const _hoisted_30 = { class: "price-number" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "separator" }, "/", -1)
const _hoisted_32 = { class: "price-frequency" }
const _hoisted_33 = {
  key: 0,
  class: "button-container"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "circle-switch" }, null, -1)
const _hoisted_35 = { class: "text-container" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "text-container" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "circle-switch" }, null, -1)
const _hoisted_40 = { class: "text-container" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "circle-switch" }, null, -1)
const _hoisted_43 = { class: "option-container" }
const _hoisted_44 = { class: "option-label" }
const _hoisted_45 = { class: "buttons-container" }
const _hoisted_46 = { class: "product-description" }
const _hoisted_47 = { class: "container header-padding-compensation" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-lg-6" }
const _hoisted_50 = { class: "product-description-text" }
const _hoisted_51 = { class: "block-headline" }
const _hoisted_52 = {
  key: 0,
  class: "col-lg-6"
}
const _hoisted_53 = { class: "image-container" }
const _hoisted_54 = ["srcset", "alt"]
const _hoisted_55 = ["srcset", "alt"]
const _hoisted_56 = ["srcset", "alt"]
const _hoisted_57 = ["srcset", "alt"]
const _hoisted_58 = ["src", "alt"]
const _hoisted_59 = {
  key: 0,
  class: "button-container"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "circle-switch" }, null, -1)
const _hoisted_61 = { class: "text-container" }
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = {
  key: 0,
  class: "previous-products"
}
const _hoisted_64 = { class: "container header-padding-compensation" }
const _hoisted_65 = { class: "block-headline" }
const _hoisted_66 = { class: "absolute-white-background" }
const _hoisted_67 = { class: "container header-padding-compensation" }
const _hoisted_68 = { class: "container header-padding-compensation" }
const _hoisted_69 = { class: "product-image" }
const _hoisted_70 = ["src", "alt"]
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-12 offset-0 offset-lg-6 col-lg-6 order-1 order-lg-2" }
const _hoisted_73 = { class: "slide-product-text" }
const _hoisted_74 = { class: "slide-product-headline" }
const _hoisted_75 = ["innerHTML"]
const _hoisted_76 = {
  key: 1,
  class: "relevant-partner"
}
const _hoisted_77 = { class: "container header-padding-compensation" }
const _hoisted_78 = ["innerHTML"]
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-12 col-lg-5" }
const _hoisted_81 = { class: "partner-image" }
const _hoisted_82 = ["srcset", "alt"]
const _hoisted_83 = ["srcset", "alt"]
const _hoisted_84 = ["srcset", "alt"]
const _hoisted_85 = ["srcset", "alt"]
const _hoisted_86 = ["src", "alt"]
const _hoisted_87 = { class: "col-12 col-lg-7" }
const _hoisted_88 = { class: "partner-description" }
const _hoisted_89 = {
  key: 2,
  class: "customer-reviews"
}
const _hoisted_90 = { class: "container header-padding-compensation" }
const _hoisted_91 = { class: "headline-section" }
const _hoisted_92 = { class: "block-headline" }
const _hoisted_93 = {
  type: "button",
  class: "btn btn-outline-dark btn-sm"
}
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-lg-6" }
const _hoisted_96 = { class: "review-section" }
const _hoisted_97 = ["innerHTML"]
const _hoisted_98 = { class: "review-info" }
const _hoisted_99 = { class: "review-name" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "review-social" }, null, -1)
const _hoisted_101 = { class: "review-rating" }
const _hoisted_102 = { class: "rating-star" }
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_placeholder = _resolveComponent("b-placeholder")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_collapse = _resolveComponent("b-collapse")!
  const _component_truncate = _resolveComponent("truncate")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_SellingPoints = _resolveComponent("SellingPoints")!
  const _component_SubscriptionsBanner = _resolveComponent("SubscriptionsBanner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_breadcrumb, { items: _ctx.BreadcrumbsItems }, null, 8, ["items"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.ready)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_b_placeholder, {
                      class: "placeholder",
                      width: "100%",
                      style: {"height":"485px"}
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-4",
                    width: "100%",
                    style: {"height":"50px"}
                  }),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-4",
                    width: "100%",
                    style: {"height":"16px"}
                  }),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_b_placeholder, {
                      class: "placeholder",
                      width: "40%",
                      style: {"height":"50px"}
                    }),
                    _createVNode(_component_b_placeholder, {
                      class: "placeholder",
                      width: "50%",
                      style: {"height":"50px"}
                    })
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.Product.IsComingSoon)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('website.coming-soon')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("div", _hoisted_17, [
                      _createElementVNode("picture", null, [
                        _createElementVNode("source", {
                          media: "only screen and (min-width: 1200px)",
                          srcset: _ctx.$imgix(_ctx.Product.PhotoUrl,'?w=480&h=485&auto=compress,format&fit=crop'),
                          class: "image-container",
                          alt: _ctx.Product.PhotoDescription
                        }, null, 8, _hoisted_18),
                        _createElementVNode("source", {
                          media: "only screen and (min-width: 992px)",
                          srcset: _ctx.$imgix(_ctx.Product.PhotoUrl,'?w=390&h=485&auto=compress,format&fit=crop'),
                          class: "image-container",
                          alt: _ctx.Product.PhotoDescription
                        }, null, 8, _hoisted_19),
                        _createElementVNode("source", {
                          media: "only screen and (min-width: 768px)",
                          srcset: _ctx.$imgix(_ctx.Product.PhotoUrl,'?w=690&h=485&auto=compress,format&fit=crop'),
                          class: "image-container",
                          alt: _ctx.Product.PhotoDescription
                        }, null, 8, _hoisted_20),
                        _createElementVNode("source", {
                          media: "only screen and (min-width: 576px)",
                          srcset: _ctx.$imgix(_ctx.Product.PhotoUrl,'?w=510&h=485&auto=compress,format&fit=crop'),
                          class: "image-container",
                          alt: _ctx.Product.PhotoDescription
                        }, null, 8, _hoisted_21),
                        _createElementVNode("img", {
                          src: _ctx.$imgix(_ctx.Product.PhotoUrl,'?w=510&h=385&auto=compress,format&fit=crop'),
                          class: "image-container",
                          alt: _ctx.Product.PhotoDescription,
                          width: "510",
                          height: "385"
                        }, null, 8, _hoisted_22)
                      ]),
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "product-edit-button",
                            to: {name: 'ProductCategoryEdit', params :{ productId: _ctx.Product.Id}}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ], undefined, true),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true)
                    ], 512), [
                      [_vShow, _ctx.ready]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("h2", _hoisted_26, _toDisplayString(_ctx.Product.Name), 1),
                    _createElementVNode("p", {
                      class: "product-short-description",
                      innerHTML: _ctx.Product.ShortDescription
                    }, null, 8, _hoisted_27),
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("div", _hoisted_29, [
                        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('website.price-currency', {price: _ctx.$n(_ctx.Product.Price, 'decimal', 'FR'), currency: _ctx.Product.Currency })), 1),
                        _hoisted_31,
                        _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t('website.delivery-small')), 1)
                      ], 512), [
                        [_vShow, _ctx.Product.Price]
                      ]),
                      (!_ctx.Product.IsComingSoon)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            (!_ctx.Product.IsActiveSubscribe)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: { name: 'CheckOut', params: { productId: _ctx.Product.Id }},
                                  class: "switch-on-button"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_34,
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("p", {
                                        innerHTML: _ctx.$t('website.switch-on-product-page-button'),
                                        class: "switch-button-text"
                                      }, null, 8, _hoisted_36)
                                    ])
                                  ], undefined, true),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.Product.IsActiveSubscribe && !_ctx.Product.SubscriptionId)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 1,
                                  to: { name: 'MyPage', hash: '#Abonnementer', params: { propProductCategoryId: _ctx.Product.Id, unsubscribe: true } },
                                  class: "switch-on-button-active"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("p", {
                                        innerHTML: _ctx.$t('website.switch-on-subscription-active'),
                                        class: "switch-button-text"
                                      }, null, 8, _hoisted_38)
                                    ]),
                                    _hoisted_39
                                  ], undefined, true),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.Product.IsActiveSubscribe && _ctx.Product.SubscriptionId)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: "switch-on-button-active",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.CollapseVisible = !_ctx.CollapseVisible))
                                }, [
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("p", {
                                      innerHTML: _ctx.$t('website.switch-on-subscription-active'),
                                      class: "switch-button-text"
                                    }, null, 8, _hoisted_41)
                                  ]),
                                  _hoisted_42
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_b_collapse, { visible: _ctx.CollapseVisible }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t('website.do-you-want-to-deactivate')), 1),
                          _createElementVNode("div", _hoisted_45, [
                            (_ctx.Product.SubscriptionId)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.unSubscribe())),
                                  class: "btn btn-outline-dark btn-sm me-2"
                                }, _toDisplayString(_ctx.$t('general.yes')), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.CollapseVisible = !_ctx.CollapseVisible)),
                              class: "btn btn-outline-dark btn-sm ms-2"
                            }, _toDisplayString(_ctx.$t('general.no')), 1),
                            _createElementVNode("div", {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.CollapseVisible = !_ctx.CollapseVisible)),
                              class: "overlay"
                            })
                          ])
                        ])
                      ], undefined, true),
                      _: 1
                    }, 8, ["visible"])
                  ])
                ])
              ])
            ]))
      ])
    ]),
    _withDirectives(_createElementVNode("section", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("h2", _hoisted_51, _toDisplayString(_ctx.$t('general.description')), 1),
              _createVNode(_component_truncate, {
                text: _ctx.Product.Description,
                length: 540,
                actionClass: 'btn btn-outline-dark mt-4',
                clamp: _ctx.$t('general.read-more'),
                less: _ctx.$t('general.read-less'),
                type: "html"
              }, null, 8, ["text", "clamp", "less"])
            ])
          ]),
          (_ctx.Product.ProductPhotoList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createVNode(_component_swiper, {
                  modules: _ctx.modules,
                  navigation: true,
                  autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                        pauseOnMouseEnter: false,
                        waitForTransition: false
                    },
                  loop: true,
                  "slides-per-view": 1.2,
                  "space-between": 30,
                  breakpoints: {
                        768: {
                        slidesPerView: 1,
                        }
                    }
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Product.ProductPhotoList, (photo) => {
                      return (_openBlock(), _createBlock(_component_swiper_slide, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("picture", null, [
                              _createElementVNode("source", {
                                media: "only screen and (min-width: 1200px)",
                                srcset: _ctx.$imgix(photo.PhotoUrl,'?w=540&h=422&auto=compress,format&fit=crop'),
                                alt: photo.Description
                              }, null, 8, _hoisted_54),
                              _createElementVNode("source", {
                                media: "only screen and (min-width: 992px)",
                                srcset: _ctx.$imgix(photo.PhotoUrl,'?w=540&h=422&auto=compress,format&fit=crop'),
                                alt: photo.Description
                              }, null, 8, _hoisted_55),
                              _createElementVNode("source", {
                                media: "only screen and (min-width: 768px)",
                                srcset: _ctx.$imgix(photo.PhotoUrl,'?w=540&h=422&auto=compress,format&fit=crop'),
                                alt: photo.Description
                              }, null, 8, _hoisted_56),
                              _createElementVNode("source", {
                                media: "only screen and (min-width: 576px)",
                                srcset: _ctx.$imgix(photo.PhotoUrl,'?w=540&h=422&auto=compress,format&fit=crop'),
                                alt: photo.Description
                              }, null, 8, _hoisted_57),
                              _createElementVNode("img", {
                                src: _ctx.$imgix(photo.PhotoUrl,'?w=540&h=422&auto=compress,format&fit=crop'),
                                alt: photo.Description,
                                width: "540",
                                height: "422"
                              }, null, 8, _hoisted_58)
                            ])
                          ])
                        ], undefined, true),
                        _: 2
                      }, 1024))
                    }), 256))
                  ], undefined, true),
                  _: 1
                }, 8, ["modules", "slides-per-view"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.Product.IsComingSoon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              (!_ctx.Product.IsActiveSubscribe)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'CheckOut', params: { productId: _ctx.Product.Id }},
                    class: "switch-on-button"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_60,
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("p", {
                          innerHTML: _ctx.$t('website.switch-on-product-page-button'),
                          class: "switch-button-text"
                        }, null, 8, _hoisted_62)
                      ])
                    ], undefined, true),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, _ctx.ready]
    ]),
    _createElementVNode("section", null, [
      _createVNode(_component_SellingPoints)
    ]),
    (_ctx.PreviousProductslItems.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("h2", _hoisted_65, _toDisplayString(_ctx.$t('website.previous-products')), 1)
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createVNode(_component_swiper, {
                modules: _ctx.modules,
                navigation: true,
                loop: true,
                spaceBetween: 30,
                slidesPerView: 1.2,
                breakpoints: {
                        768: {
                        slidesPerView: 2.3,
                        },
                        992: {
                        slidesPerView: 3.3,
                        },
                        1200: {
                        slidesPerView: 4.3,
                        }
                    }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PreviousProductslItems, (slide) => {
                    return (_openBlock(), _createBlock(_component_swiper_slide, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("img", {
                              src: slide.ImgSrc,
                              alt: slide.Name
                            }, null, 8, _hoisted_70)
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("p", _hoisted_74, _toDisplayString(slide.Name), 1),
                                _createElementVNode("p", {
                                  class: "slide-product-description",
                                  innerHTML: slide.Description
                                }, null, 8, _hoisted_75)
                              ])
                            ])
                          ])
                        ])
                      ], undefined, true),
                      _: 2
                    }, 1024))
                  }), 256))
                ], undefined, true),
                _: 1
              }, 8, ["modules", "slidesPerView", "breakpoints"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.Product.PartnerName && _ctx.Product.PartnerPhotoUrl)
      ? (_openBlock(), _createElementBlock("section", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("h2", {
              innerHTML: _ctx.Product.Name + ' ' + _ctx.$t('website.delivered-by') + ' ' + _ctx.Product.PartnerName,
              class: "section-headline"
            }, null, 8, _hoisted_78),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_router_link, {
                  class: "partner-card-link",
                  to: {name: 'PartnerPage', params: { slug: _ctx.Product.PartnerSlug || _ctx.$slugify( _ctx.Product.PartnerName)}, query: { Id: _ctx.Product.PartnerSlug? undefined :  _ctx.Product.PartnerId }}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("picture", null, [
                        _createElementVNode("source", {
                          media: "only screen and (min-width: 1200px)",
                          srcset: _ctx.$imgix(_ctx.Product.PartnerPhotoUrl,'?w=400&h=400&auto=compress,format&fit=crop'),
                          alt: _ctx.Product.PartnerName
                        }, null, 8, _hoisted_82),
                        _createElementVNode("source", {
                          media: "only screen and (min-width: 992px)",
                          srcset: _ctx.$imgix(_ctx.Product.PartnerPhotoUrl,'?w=400&h=400&auto=compress,format&fit=crop'),
                          alt: _ctx.Product.PartnerName
                        }, null, 8, _hoisted_83),
                        _createElementVNode("source", {
                          media: "only screen and (min-width: 768px)",
                          srcset: _ctx.$imgix(_ctx.Product.PartnerPhotoUrl,'?w=400&h=400&auto=compress,format&fit=crop'),
                          alt: _ctx.Product.PartnerName
                        }, null, 8, _hoisted_84),
                        _createElementVNode("source", {
                          media: "only screen and (min-width: 576px)",
                          srcset: _ctx.$imgix(_ctx.Product.PartnerPhotoUrl,'?w=340&h=340&auto=compress,format&fit=crop'),
                          alt: _ctx.Product.PartnerName
                        }, null, 8, _hoisted_85),
                        _createElementVNode("img", {
                          src: _ctx.$imgix(_ctx.Product.PartnerPhotoUrl,'?w=340&h=340&auto=compress,format&fit=crop'),
                          alt: _ctx.Product.PartnerName,
                          width: "340",
                          height: "340"
                        }, null, 8, _hoisted_86)
                      ])
                    ])
                  ], undefined, true),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _createVNode(_component_truncate, {
                    text: _ctx.Product.PartnerDescription,
                    length: 250,
                    actionClass: 'btn btn-outline-dark mt-4 relevant-partner-btn',
                    clamp: _ctx.$t('general.read-more'),
                    less: _ctx.$t('general.read-less'),
                    type: "html"
                  }, null, 8, ["text", "clamp", "less"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.CustomerReviews.length)
      ? _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_89, [
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("h2", _hoisted_92, _toDisplayString(_ctx.$t('website.customer-reviews')), 1),
              _createElementVNode("button", _hoisted_93, _toDisplayString(_ctx.$t('general.write-your-review')), 1)
            ]),
            _createElementVNode("div", _hoisted_94, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CustomerReviews, (review) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("p", {
                      class: "review-text",
                      innerHTML: review.Description
                    }, null, 8, _hoisted_97),
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", {
                        class: "review-avatar",
                        style: _normalizeStyle({ 'background-image': 'url(' + review.ImgSrc + ')' })
                      }, null, 4),
                      _createElementVNode("p", _hoisted_99, _toDisplayString(review.Name), 1),
                      _hoisted_100,
                      _createElementVNode("div", _hoisted_101, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                          return _createElementVNode("div", _hoisted_102, [
                            (star <= review.Rating)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_103, "★"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_104, "☆"))
                          ])
                        }), 64))
                      ])
                    ])
                  ])
                ]))
              }), 256))
            ])
          ])
        ], 512)), [
          [_vShow, _ctx.ready]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_SubscriptionsBanner)
  ]))
}